import React from "react";
import CountUp from "./CountUp";

const ServiceCount = ({ title, desc, data }) => {
  return (
    <div
      style={{ backgroundColor: "white", border: "1px solid transparent" }}
      id="impact-container"
    >
      <div>
        <div className="text-center text-black" id="impact-title">
          {title || "Live Dashboard"}
        </div>
      </div>
      <div className="text-black mt-2" id="impact-desc">
        {desc || (
          <>
            Empowering businesses with innovative web solutions, standout
            designs,
            <br />
            and seamless technology to drive success
          </>
        )}
      </div>
      <div
        className="impact-box-container text-center"
        data-path={window.location.pathname}
      >
        {data && data.length > 0 ? (
          data.map((service, index) => (
            <div key={index} className="impact-box-wrapper">
              <div className="impact-box">
                <CountUp
                  targetValue={service.count}
                  duration={1000}
                  suffix={service.suffix}
                />
              </div>
              <div>
                <span dangerouslySetInnerHTML={{ __html: service.desc }} />
              </div>
            </div>
          ))
        ) : (
          <>
            <div>
              <div className="impact-box">
                <CountUp targetValue={10} duration={1000} suffix={"+"} />
              </div>
              <div>
                <span>
                  Startups <br /> Transformed
                </span>
              </div>
            </div>
            <div>
              <div className="impact-box">
                <CountUp targetValue={25} duration={1000} suffix={"+"} />
              </div>
              <div>
                <span>
                  MVPs <br /> Launched
                </span>
              </div>
            </div>
            <div>
              <div className="impact-box">
                <CountUp targetValue={11} duration={1000} suffix={"+"} />
              </div>
              <div>
                <span>
                  Active <br /> Projects
                </span>
              </div>
            </div>
            <div>
              <div className="impact-box">
                <CountUp targetValue={1000} duration={1000} suffix={"+"} />
              </div>
              <div>
                <span>
                  Mentorship <br /> Hours
                </span>
              </div>
            </div>
            <div>
              <div className="impact-box">
                <CountUp targetValue={5} duration={1000} suffix={"+"} />
              </div>
              <div>
                <span>
                  Countries <br /> Presence
                </span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ServiceCount;
